module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_5.d047f214.png";